/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { VivaLiteScanStrictHttpResponse } from '../../viva-lite-scan-strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ScanSdkScanResultModel } from '../../models/scan-sdk-scan-result-model';
import { ScanSessionResultModel } from '../../models/scan-session-result-model';

export interface ScanSubmitSdkSessionPost$Params {
  
    /**
     * The SDK scan result model containing scan data
     */
    body?: ScanSdkScanResultModel
}

export function scanSubmitSdkSessionPost(http: HttpClient, rootUrl: string, params?: ScanSubmitSdkSessionPost$Params, context?: HttpContext): Observable<VivaLiteScanStrictHttpResponse<ScanSessionResultModel>> {
  const rb = new RequestBuilder(rootUrl, scanSubmitSdkSessionPost.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as VivaLiteScanStrictHttpResponse<ScanSessionResultModel>;
    })
  );
}

scanSubmitSdkSessionPost.PATH = '/Scan/SubmitSDKSession';
